export default {
  'loading.title': 'Loading Resources',
  'loading.subtitle': 'Please wait...',
  'loading.initial.title': 'Loading Resources',
  'loading.initial.subtitle': 'Initial loading may take some time. Please wait.',
};
